import { MobilePageLayout } from 'elements/eventView/layout/MobilePageLayout';
import { EVDetailPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVDetailPageMobile';
import { EVFormPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVFormPageMobile';
import { EVInformationPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVInformationPageMobile';
import { EVMapPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVMapPageMobile';
import { EVOtherEntitiesPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVOtherEntitiesPageMobile';
import { EVOverviewPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVOverviewPageMobile';
import { EVProgramPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVProgramPageMobile';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { Route, Routes, matchPath, useLocation } from 'react-router-dom';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EVPageMobile = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);
    const location = useLocation();

    const isMapRoute = !!matchPath(
        {
            path: '/event/:eventId/map/*'
        },
        location.pathname
    );

    function checkPath(path: string) {
        return !!matchPath(
            {
                path: path
            },
            location.pathname
        );
    }

    function getBgStyle() {
        if (checkPath('/event/:eventId')) {
            return {
                backgroundImage: `url(${ctxEventView.eventData.eventInfo.brandImageUrl})`
            };
        } else if (checkPath('/event/:eventId/program')) {
            return {
                backgroundColor: '#F6F9FF'
            };
        } else {
            return {
                backgroundColor: '#EAF0F5'
            };
        }
    }

    useEffect(() => {
        if (ctxEventView.scrollToTop) {
            document.getElementById('scrollmobile')?.scrollIntoView();
            ctxEventView.setScrollToTop(false);
        }
    }, [ctxEventView.scrollToTop]);

    useEffect(() => {
        if (checkPath('/event/:eventId')) {
            const element = document.getElementById('scrollmobilelanding');
            if (element) {
                if (ctxEventView.scrollToTop) {
                    element.scrollTop = 0;
                } else {
                    const scrollPosition = JSON.parse(
                        localStorage.getItem('scrollPosition') || '0'
                    );
                    element.scrollTop = scrollPosition;
                    console.log('scrollPosition', scrollPosition, element);
                }
            }
        }
    }, [location.pathname]);

    return (
        <S_EVPageMobile className={props.className}>
            <MobilePageLayout background={getBgStyle()}>
                <Routes location={location} key={location.pathname}>
                    <Route path="/program/*" element={<EVProgramPageMobile />} />
                    <Route path="/detail/:detailId" element={<EVDetailPageMobile />} />
                    <Route path="/information" element={<EVInformationPageMobile />} />
                    <Route path="/form/:eventFormId" element={<EVFormPageMobile />} />
                    <Route path="/" element={<EVOverviewPageMobile />} />
                    <Route path="/highlighted/*" element={<EVOverviewPageMobile />} />
                    {ctxEventView.otherEntityDefinitions.map((e) => (
                        <Route
                            key={e.id}
                            path={`/${e.id}/*`}
                            element={<EVOtherEntitiesPageMobile entityDefinitionId={e.id} />}
                        />
                    ))}
                </Routes>
                <S_EVMapPageMobile $isVisible={isMapRoute} />
            </MobilePageLayout>
        </S_EVPageMobile>
    );
};

const S_EVPageMobile = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    user-select: none;
`;

const S_EVMapPageMobile = styled(EVMapPageMobile)<{ $isVisible: boolean }>`
    display: ${(props) => (props.$isVisible ? 'flex' : 'none')};
`;
